var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FCB918"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9282 51.8564L30.9282 44.9282L42.9282 38L42.9282 51.8564Z",
    fill: "#FCB918"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 21.994C14.9995 21.2062 15.1544 20.426 15.4558 19.6982C15.7572 18.9703 16.1992 18.3091 16.7565 17.7523C17.3139 17.1955 17.9756 16.7542 18.7037 16.4535C19.4319 16.1528 20.2122 15.9987 21 16H29C32.313 16 35 18.695 35 21.994V34H21C17.687 34 15 31.305 15 28.006V21.994ZM33 32V21.994C32.9974 20.9345 32.5749 19.9192 31.8251 19.1706C31.0754 18.422 30.0595 18.0011 29 18H21C20.4748 17.9987 19.9546 18.1011 19.4691 18.3012C18.9836 18.5014 18.5424 18.7955 18.1708 19.1665C17.7991 19.5376 17.5044 19.9784 17.3035 20.4636C17.1026 20.9488 16.9995 21.4689 17 21.994V28.006C17.0026 29.0655 17.4251 30.0808 18.1749 30.8294C18.9246 31.578 19.9405 31.999 21 32H33ZM27 24H29V26H27V24ZM21 24H23V26H21V24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/Chaticon.96224382ba55aa7ce0765de16d38110e.svg";
export { ForwardRef as ReactComponent };